(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gif-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function init(section) {
      if (!section || section.dataset.svcReady) return;
      section.dataset.svcReady = '1';

      var sid = section.dataset.svc;
      var track = section.querySelector('.svc__track');
      var cards = Array.prototype.slice.call(section.querySelectorAll('.svc__card'));
      if (!cards.length) return;

      /* ---- position like/share icons on the video's bottom edge ---- */
      function placeIcons() {
        cards.forEach(function (c) {
          var m = c.querySelector('.svc__media');
          if (m) c.style.setProperty('--svc-media-h', m.offsetHeight + 'px');
        });
      }
      placeIcons();
      window.addEventListener('resize', placeIcons);

      /* ---- carousel arrows ---- */
      var prevBtn = section.querySelector('.svc__arrow--prev');
      var nextBtn = section.querySelector('.svc__arrow--next');
      function updateArrows() {
        prevBtn.hidden = track.scrollLeft <= 4;
        nextBtn.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      section.querySelectorAll('[data-svc-scroll]').forEach(function (b) {
        b.addEventListener('click', function () {
          track.scrollBy({ left: Number(b.dataset.svcScroll) * track.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();

      /* GIFs can finish loading after first paint, so re-measure icon position */
      section.querySelectorAll('.svc__gif').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', placeIcons, { once: true });
      });

      /* ---- likes (remembered per visitor) ---- */
      function isLiked(id) { try { return localStorage.getItem('svc-like-' + id) === '1'; } catch (e) { return false; } }
      function setLiked(id, val) { try { localStorage.setItem('svc-like-' + id, val ? '1' : '0'); } catch (e) {} }
      function likeCount(card) { return (parseInt(card.dataset.likes, 10) || 0) + (isLiked(card.dataset.id) ? 1 : 0); }
      function syncCardLike(card) {
        var b = card.querySelector('[data-svc-like]');
        if (b) b.setAttribute('aria-pressed', isLiked(card.dataset.id) ? 'true' : 'false');
      }
      cards.forEach(syncCardLike);

      /* ---- share ---- */
      function shareUrl(card) { return location.origin + location.pathname + '#svc-' + card.dataset.id; }
      function share(card, toastFn) {
        var url = shareUrl(card);
        var title = card.dataset.title || document.title;
        if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () { toastFn && toastFn('Link copied'); });
        } else { window.prompt('Copy this link', url); }
      }

      /* ---- add to cart ---- */
      function addToCart(card, btn, action) {
        if (!card.dataset.variant) return;
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(card.dataset.variant), quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add to cart'); return j; }); })
          .then(function (res) {
            document.dispatchEvent(new CustomEvent('svc:added', { detail: res }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (action === 'checkout') { location.href = ROOT + 'checkout'; return; }
            if (action === 'cart') { location.href = ROOT + 'cart'; return; }
            btn.textContent = 'Added to cart';
            setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
          })
          .catch(function (err) {
            btn.textContent = err.message;
            setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
          });
      }

      cards.forEach(function (card, i) {
        card.querySelector('[data-svc-open]').addEventListener('click', function () { open(i); });
        var likeBtn = card.querySelector('[data-svc-like]');
        likeBtn.addEventListener('click', function () {
          setLiked(card.dataset.id, !isLiked(card.dataset.id));
          syncCardLike(card);
        });
        card.querySelector('[data-svc-share]').addEventListener('click', function () { share(card, function (t) { alert(t); }); });
        var buy = card.querySelector('[data-svc-buy]');
        if (buy) buy.addEventListener('click', function () { addToCart(card, buy, section.dataset.buyAction); });
      });

      /* ---- popup player ---- */
      var old = document.getElementById('svc-modal-' + sid);
      if (old) old.remove();
      var tpl = section.querySelector('template[data-svc-modal]');
      var modal = tpl.content.firstElementChild.cloneNode(true);
      document.body.appendChild(modal);

      var $ = function (k) { return modal.querySelector('[data-m="' + k + '"]'); };
      var video = $('video');
      var idx = 0;
      var lastFocus = null;
      var unmuted = section.dataset.autoplaySound === 'true';

      function toast(text) {
        var t = $('toast');
        t.textContent = text;
        t.classList.add('is-show');
        clearTimeout(t._h);
        t._h = setTimeout(function () { t.classList.remove('is-show'); }, 1600);
      }

      function applyMute() {
        video.muted = !unmuted;
        modal.classList.toggle('is-unmuted', unmuted);
      }

      function render() {
        var c = cards[idx];
        var d = c.dataset;
        video.src = d.video || '';
        if (d.poster) video.poster = d.poster; else video.removeAttribute('poster');
        applyMute();
        video.play().catch(function () {
          unmuted = false; applyMute(); video.play().catch(function () {});
        });

        $('viewsWrap').hidden = !d.views;
        $('views').textContent = d.views || '';
        $('like').setAttribute('aria-pressed', isLiked(d.id) ? 'true' : 'false');
        $('likes').textContent = likeCount(c);

        var hasProduct = !!d.variant;
        $('product').hidden = !hasProduct;
        if (hasProduct) {
          var off = parseInt(d.off, 10) || 0;
          $('badge').textContent = d.save ? 'Save ' + d.save + '!' : (off > 0 ? off + '% OFF!' : '');
          $('thumb').src = d.thumb || '';
          $('thumb').hidden = !d.thumb;
          $('title').textContent = d.title;
          $('title').href = d.url;
          $('link').href = d.url;
          $('price').textContent = d.price;
          $('compare').textContent = d.compare || '';
          $('off').textContent = off > 0 ? off + '% Off' : '';
          var atc = $('atc');
          var available = d.available === 'true';
          atc.disabled = !available;
          atc.textContent = available ? atc.dataset.label : 'Sold out';
        }

        $('prev').disabled = idx === 0;
        $('next').disabled = idx === cards.length - 1;
      }
      $('atc').dataset.label = $('atc').textContent;

      function open(i) {
        idx = i;
        lastFocus = document.activeElement;
        modal.classList.add('is-open');
        document.documentElement.classList.add('svc-lock');
        render();
        $('close').focus();
        if (history.replaceState) history.replaceState(null, '', '#svc-' + cards[idx].dataset.id);
      }
      function close() {
        modal.classList.remove('is-open');
        document.documentElement.classList.remove('svc-lock');
        video.pause();
        video.removeAttribute('src');
        video.load();
        if (history.replaceState) history.replaceState(null, '', location.pathname + location.search);
        if (lastFocus) lastFocus.focus();
      }
      function go(step) {
        var n = idx + step;
        if (n < 0 || n >= cards.length) return;
        idx = n;
        render();
        if (history.replaceState) history.replaceState(null, '', '#svc-' + cards[idx].dataset.id);
      }

      $('close').addEventListener('click', close);
      $('prev').addEventListener('click', function () { go(-1); });
      $('next').addEventListener('click', function () { go(1); });
      $('mute').addEventListener('click', function () { unmuted = !unmuted; applyMute(); });
      video.addEventListener('click', function () { video.paused ? video.play() : video.pause(); });
      $('like').addEventListener('click', function () {
        var c = cards[idx];
        setLiked(c.dataset.id, !isLiked(c.dataset.id));
        syncCardLike(c);
        render.call(null);
      });
      $('share').addEventListener('click', function () { share(cards[idx], toast); });
      $('atc').addEventListener('click', function () { addToCart(cards[idx], $('atc'), section.dataset.addAction); });

      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) {
        if (!modal.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') go(1);
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') go(-1);
      });

      /* swipe up/down on mobile, like reels */
      var y0 = null;
      var stage = modal.querySelector('.svc-modal__stage');
      stage.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (y0 === null) return;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dy) > 60) go(dy < 0 ? 1 : -1);
        y0 = null;
      });

      /* open straight to a shared video */
      cards.forEach(function (c, i) { if (location.hash === '#svc-' + c.dataset.id) open(i); });
    }

    function initAll() { document.querySelectorAll('[data-svc]').forEach(init); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();

    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-svc]')); });
    document.addEventListener('shopify:section:unload', function (e) {
      var s = e.target.querySelector('[data-svc]');
      if (s) { var m = document.getElementById('svc-modal-' + s.dataset.svc); if (m) m.remove(); }
      document.documentElement.classList.remove('svc-lock');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
